export const environment = {
    production: true,
    version: '1.0.01',
    baseUrl: 'http://3.110.39.29:8090/',
    cookieDomain : 'http://3.110.39.29:8090//',
    apiVersion: '',
    external:false
};
// Build 
// ng build --configuration production